export default __webpack_public_path__ + "static/logo-e34c084fff97752a72b3d6d8e8409614.svg";